// Spielbezug einer Einzelspiel-Wette (AllBets[].Match: { Id, Opponent, RoundLabel }).
// Das Label der Wette trägt den Gegner nicht - Spieltag und Gegner kommen aus dem Spielbezug.
// Bei Wetten ohne Spiel fehlt das Feld ganz.

// Gleichlautende Labels verschiedener Spiele sind verschiedene Wetten, daher nach Label UND Spiel gruppieren.
export function betGroupKey(bet) {
    return `${bet.BetStr}|${bet.Match?.Id ?? ''}`;
}

// "3. Spieltag · FC Schalke 04" - ohne Runde nur der Gegner.
export function formatMatch(match) {
    if (!match) return '';
    return [match.RoundLabel, match.Opponent].filter(Boolean).join(' · ');
}

// Anstoß als Sortierschlüssel; ein Spiel ohne Anstoß (Feld fehlt) sortiert hinter alle datierten.
// Die Spiel-Id taugt nicht (Zufalls-UUID), die Runde auch nicht (Freitext, Pokal, Nachholspiele).
function kickoffTime(match) {
    const time = match.KickoffAt ? Date.parse(match.KickoffAt) : NaN;
    return Number.isNaN(time) ? Infinity : time;
}

// Teilt Wetten in Abschnitte je Spiel, chronologisch aufsteigend. Die Reihenfolge der Wetten innerhalb
// eines Abschnitts bleibt erhalten; Wetten ohne Spielbezug kommen gesammelt und ohne Spiel ans Ende.
// Ein Block ganz ohne Spielbezug ergibt so einen einzigen Abschnitt (Match: null) - wie bisher.
export function groupByMatch(bets) {
    const sectionsByMatchId = new Map();
    const withoutMatch = [];

    for (const bet of bets) {
        if (!bet.Match) {
            withoutMatch.push(bet);
            continue;
        }
        if (!sectionsByMatchId.has(bet.Match.Id)) {
            sectionsByMatchId.set(bet.Match.Id, { Match: bet.Match, Bets: [] });
        }
        sectionsByMatchId.get(bet.Match.Id).Bets.push(bet);
    }

    // Explizit verglichen statt subtrahiert: Infinity - Infinity wäre NaN und die Sortierung undefiniert.
    const sections = [...sectionsByMatchId.values()].sort((a, b) => {
        const timeA = kickoffTime(a.Match);
        const timeB = kickoffTime(b.Match);
        return timeA === timeB ? 0 : timeA < timeB ? -1 : 1;
    });

    if (withoutMatch.length > 0) sections.push({ Match: null, Bets: withoutMatch });
    return sections;
}
